









import { mapGetters } from 'vuex'
//import { Component, Vue } from 'vue-property-decorator'

import Vue from 'vue';
import toolbarhp from './components/PaginaInicio/toolbarhp.vue';
import footerhp from './components/PaginaInicio/footerhp.vue';

export default({
  name: 'App',
  data: () => ({
    //
  }),
    components: {
      toolbarhp,
      footerhp,
  },
  computed: {
    ...mapGetters('oidcStore', [
                'oidcIsAuthenticated'
            ])
  }
});
